var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 31,
    viewBox: "0 0 40 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C2",
    fillRule: "nonzero",
    d: "M39.543 9.76L30.323.5a1.557 1.557 0 0 0-2.209 0l-3.505 3.52L21.105.5a1.557 1.557 0 0 0-2.21 0l-3.504 3.52L11.886.5a1.557 1.557 0 0 0-2.21 0L.459 9.76A1.572 1.572 0 0 0 0 10.87V29.39c0 .867.7 1.57 1.563 1.57h36.874c.864 0 1.563-.703 1.563-1.57V10.87c0-.417-.164-.816-.457-1.11zM20 3.829l7.656 7.69v16.303h-6.093V10.87c0-.417-.165-.816-.458-1.11L17.6 6.24 20 3.828zm-16.875 7.69l7.656-7.69 7.656 7.69v16.303h-3.02V20.13c0-.867-.7-1.57-1.563-1.57H7.708c-.863 0-1.562.703-1.562 1.57v7.692H3.125V11.52zm9.167 16.303H9.27V21.7h3.02v6.122zm24.583 0h-6.094V10.87c0-.417-.164-.816-.457-1.11l-3.505-3.52 2.4-2.411 7.656 7.69v16.303z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseIcon);
export default __webpack_public_path__ + "static/media/house-icon.f6bce74c7848a110da3c2acaee6fbb74.svg";
export { ForwardRef as ReactComponent };